import { classQuery, classSurroundingsQuery, searchQuery } from "../async-queryable/queries.js";
import { QUERYABLE_MODEL } from "../../model/known-models.js";
export class ExternalSemanticModel {
    id;
    model;
    observableModel;
    constructor(model, observableModel, id) {
        this.id = id ?? (Math.random() + 1).toString(36).substring(7);
        this.model = model;
        this.observableModel = observableModel;
    }
    serializeModel() {
        return {
            type: QUERYABLE_MODEL,
            id: this.id,
            queries: Object.keys(this.observableModel.queries),
        };
    }
    async unserializeModel(data) {
        const modelDescriptor = data;
        this.id = modelDescriptor.id;
        const queries = modelDescriptor.queries;
        for (const query of queries) {
            await this.observableModel.addQuery(query);
        }
    }
    getId() {
        return this.id;
    }
    getAlias() {
        return this.id;
    }
    setAlias(alias) {
        return;
    }
    getEntities() {
        return this.observableModel.getEntities();
    }
    subscribeToChanges(callback) {
        return this.observableModel.subscribeToChanges(callback);
    }
    /**
     * Searches for a given string and returns a list of classes that were found.
     * @param query search string, may contain regex if supported
     */
    async search(query) {
        const iri = searchQuery(query);
        const result = await this.model.query(iri);
        const searchQueryEntity = result[iri];
        return searchQueryEntity.order.map((iri) => result[iri]);
    }
    async allowClass(id) {
        const query = classQuery(id);
        await this.observableModel.addQuery(query);
    }
    async releaseClass(id) {
        const query = classQuery(id);
        await this.observableModel.releaseQuery(query);
    }
    async getSurroundings(id) {
        const query = classSurroundingsQuery(id);
        const result = await this.model.query(query);
        return Object.values(result);
    }
    async allowClassSurroundings(id) {
        const query = classSurroundingsQuery(id);
        await this.observableModel.addQuery(query);
    }
    async releaseClassSurroundings(id) {
        const query = classSurroundingsQuery(id);
        await this.observableModel.releaseQuery(query);
    }
    async getFullHierarchy(id) {
        const query = "hierarchy:" + id;
        return Object.values(await this.model.query(query));
    }
}
//# sourceMappingURL=external-semantic-model.js.map